//
//
//
//
//
//
//
//
//
//

// import layer from '@/components/layer/layer.vue'
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              planBScroll:null,
              content:'',
            }
        },
       
        mounted(){
           
        },
        methods:{
          showoast(str){
            this.showFlag = true;
          },
          close(){
            console.log("a")
            // this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
